/**
 * Закрытые словари витрины курсов.
 *
 * Зачем отдельным файлом: фильтры и теги собираются из этих массивов, а не перебором строк
 * в courses.data.js. Иначе опечатка в одном курсе молча порождает новое «направление»,
 * а фильтр по нему находит ровно один курс.
 *
 * Цвета тегов проверены на контраст к белому (WCAG AA для мелкого текста — минимум 4.5:1):
 *   #163269 — 12.39:1   #0F6E78 — 5.96:1   #4E6373 — 6.26:1
 *   #8A6D00 —  4.92:1   #1F6B4A — 6.44:1
 * Фирменный #ffdd57 даёт 1.33:1 и как цвет текста непригоден — только заливка, текст на ней чёрный.
 * clrs.grey #6F8695 даёт 3.80:1 и AA не проходит, поэтому взят затемнённый #4E6373.
 */

/**
 * Направления. Порядок задаёт порядок в фильтре.
 *
 * Набор пересобран под реальные курсы заказчика: в документах направление не
 * указано, а прежние пять корзин не вмещали PowerPoint и Power BI.
 */
export const CATEGORIES = [
    {code: 'ai-functions', labelKey: 'coursesPage.category.ai-functions', text: '#163269', bg: '#EEF3FA'},
    {code: 'ai-dev', labelKey: 'coursesPage.category.ai-dev', text: '#0F6E78', bg: '#E6F2F3'},
    {code: 'data-analytics', labelKey: 'coursesPage.category.data-analytics', text: '#4E6373', bg: '#EEF1F3'},
    {code: 'office-skills', labelKey: 'coursesPage.category.office-skills', text: '#8A6D00', bg: '#FFF7DB'},
    {code: 'management', labelKey: 'coursesPage.category.management', text: '#7A3E9D', bg: '#F3EAF9'},
    {code: 'languages', labelKey: 'coursesPage.category.languages', text: '#1F6B4A', bg: '#E9F3ED'},
];

/**
 * Формат проведения. «Уточняется» — не заглушка от нас, а то, что написано
 * в документах части курсов; редактор меняет значение, когда формат определён.
 */
export const FORMATS = [
    {code: 'offline', labelKey: 'coursesPage.format.offline'},
    {code: 'online', labelKey: 'coursesPage.format.online'},
    {code: 'blended', labelKey: 'coursesPage.format.blended'},
    {code: 'tbd', labelKey: 'coursesPage.format.tbd'},
];

/** Уровень подготовки. Языковые курсы описаны по шкале CEFR — она указана в документах. */
export const LEVELS = [
    {code: 'basic', labelKey: 'coursesPage.level.basic'},
    {code: 'medium', labelKey: 'coursesPage.level.medium'},
    {code: 'advanced', labelKey: 'coursesPage.level.advanced'},
    {code: 'a2-b1', labelKey: 'coursesPage.level.a2-b1'},
    {code: 'mixed', labelKey: 'coursesPage.level.mixed'},
    {code: 'tbd', labelKey: 'coursesPage.level.tbd'},
];

/**
 * Роли слушателей. Показываются мелкими чипами на странице курса.
 * Фильтром по ним не фильтруем: на 12 курсах распределение слишком дробное,
 * чтобы такой фильтр что-то резал.
 */
export const AUDIENCES = [
    {code: 'hr', labelKey: 'coursesPage.audience.hr'},
    {code: 'legal', labelKey: 'coursesPage.audience.legal'},
    {code: 'finance', labelKey: 'coursesPage.audience.finance'},
    {code: 'procurement', labelKey: 'coursesPage.audience.procurement'},
    {code: 'marketing', labelKey: 'coursesPage.audience.marketing'},
    {code: 'it', labelKey: 'coursesPage.audience.it'},
    {code: 'support', labelKey: 'coursesPage.audience.support'},
    {code: 'gov', labelKey: 'coursesPage.audience.gov'},
    {code: 'managers', labelKey: 'coursesPage.audience.managers'},
    {code: 'analysts', labelKey: 'coursesPage.audience.analysts'},
    {code: 'specialists', labelKey: 'coursesPage.audience.specialists'},
];

/** Группы фильтров каталога и их ключи в query-строке URL. */
export const FILTER_GROUPS = [
    {key: 'dir', field: 'category', titleKey: 'coursesPage.filters.direction', options: CATEGORIES},
    {key: 'fmt', field: 'format', titleKey: 'coursesPage.filters.format', options: FORMATS},
    {key: 'lvl', field: 'level', titleKey: 'coursesPage.filters.level', options: LEVELS},
];

const byCode = (list) => Object.fromEntries(list.map((x) => [x.code, x]));

export const CATEGORY_BY_CODE = byCode(CATEGORIES);
export const FORMAT_BY_CODE = byCode(FORMATS);
export const LEVEL_BY_CODE = byCode(LEVELS);
export const AUDIENCE_BY_CODE = byCode(AUDIENCES);
